import { render, staticRenderFns } from "./ViewTicketDetailsModal.vue?vue&type=template&id=74625c9c"
import script from "./ViewTicketDetailsModal.vue?vue&type=script&lang=js"
export * from "./ViewTicketDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports